import { UX2 } from '@wsb/guac-widget-core';

// Match ContentCard pattern exactly: tag = UX2 element class (not string),
// returned directly via this.merge (not via this.Block/this.Heading).

export function ReviewerAvatar({ children, style: styleOverride = {}, ...props }) {
  const finalStyle = {
    width: '100px',
    height: '100px',
    borderRadius: '50%',
    backgroundColor: 'rgba(240,240,240,0.8)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    ...styleOverride
  };
  return this.merge(
    {
      tag: UX2.Element.Block,
      children,
      style: finalStyle
    },
    props
  );
}

export function ReviewerInitial({ children, style: styleOverride = {}, ...props }) {
  // Use Block (neutral element) instead of Heading so the letter doesn't
  // inherit theme-specific heading typography overrides (e.g. Aurora's
  // bold HeadingAlpha) which make it look thicker than on other themes.
  const finalStyle = {
    color: '#CBCBCB',
    lineHeight: '1',
    padding: 'medium',
    fontSize: 'xxxlarge',
    fontWeight: 'normal',
    ...styleOverride
  };
  return this.merge(
    {
      tag: UX2.Element.Block,
      children,
      style: finalStyle
    },
    props
  );
}
